import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';

export const updatePurchaseSortMode = async (isActive: boolean) => {
    // @ts-ignore
    const url = routable.getRoute('savePurchasePageInSortModeUrl');
    try {
        // @ts-ignore
        loader.show();
        await $api.get(`${url}?value=${isActive ? 'on' : 'off'}`);
        return isActive;
    } catch (error) {
        handleAxiosFetchErrorsSwal(error?.response?.data);
        return error;
    }
};
